export const GraphLine = ({
  fillColor,
  width = '10rem',
}: {
  fillColor: string;
  width?: string;
}) => (
  <svg width={width} viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
    {/* Axes */}
    <line x1='0' y1='0' x2='0' y2='20' stroke={fillColor} strokeWidth={1} />
    <line x1='0' y1='20' x2='20' y2='20' stroke={fillColor} strokeWidth={1} />
    {/* Chart */}
    <polyline
      points='2,8.5 6.5,4.5 10,11 14.5,9.5 18,13.5'
      fill='none'
      stroke={fillColor}
      strokeWidth={0.5}
    />
  </svg>
);
